module.exports = __webpack_public_path__ + "image/sub_nav_8.png";